import http from '@/utils/http' //引入axios
export const gettotal = data => http.get('/rvm-center/api/machine/home/total', {
    params: data
}) //查找条码

export default {
    gettotal,

    // findBarcode
}